import { getValueFromSearchParams } from "./index";

/**
 * 版本号枚举
 */
export enum VersionIdEnum {
  // 10000639 版本号
  VERSION_10000639 = '5.0.5.107192',
}

/**
 * 版本号工具类
 * 用于处理版本号相关的逻辑
 */
export class VersionIdUtil {

  // 主版本号正则表达式
  private static _mainVersionRegex = /^5\.0\.5\.\d+$/;
  // 版本号
  private static _versionId: string | null = null;

  /**
   * 获取版本号
   * @returns 版本号
   */
  public static getVersionId(): string | null {
    if (this._versionId === null) {
      this._versionId = getValueFromSearchParams('sdVersion');
    }
    return this._versionId;
  }

  /**
   * 判断主版本号是否有效
   * @param input 版本号
   * @returns 是否有效
   */
  public static isMainVersionValid(versionId: string | null = this.getVersionId()): boolean {
    if (versionId === null || versionId.trim() === '') {
      return false;
    }
    return this._mainVersionRegex.test(versionId);
  }

  /**
   * 判断当前版本号是否大于指定版本号
   * @param targetVersion 目标版本号
   * @returns 当前版本号是否大于目标版本号
   */
  public static isCurrentVersionGreaterThan(targetVersion: VersionIdEnum): boolean {
    const currentVersionId = this.getVersionId();
    if (!this.isMainVersionValid(currentVersionId)) {
      return false;
    }
    const currentVersionNumber = parseInt(currentVersionId!.split('.').pop() || '0', 10);
    const targetVersionNumber = parseInt(targetVersion.split('.').pop() || '0', 10);
    return currentVersionNumber >= targetVersionNumber;
  }
}